
import { switchMap, catchError, retry } from 'rxjs/operators';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Router } from '@angular/router';
import { Injectable } from "@angular/core";
import { Observable, of, Subscription, throwError, timer } from 'rxjs';
import { AuthDataService } from '../api/auth-data.service';
import { environment } from '../../../environments/environment.prod';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    private inactivityTimeout = 1800000; // 30 minutes (18,00,000 ms) 
    public accessToken: any;
    private inactivityTimer$: Subscription | null = null;

    constructor(private router: Router, private authService: AuthDataService) {
        this.startInactivityTimer();
    }


    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        let domain = environment.domainName;
        const request = req.clone({
            headers: req.headers.set(
                'Authorization', "Bearer " + localStorage.getItem("Authorization-Token")
            ),
            url: domain + req.url
        });

        // Reset the inactivity timer on each API call
        this.resetInactivityTimer();

        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401) {
                    if (err.statusText == "UNAUTHORIZED" || err.statusText == "Unauthorized") {
                        const refresh_token = localStorage.getItem('Refresh-Token')
                        return this.authService.refreshToken(refresh_token).pipe(
                            switchMap((authResponse) => {
                                localStorage.setItem("Authorization-Token", authResponse.accessToken)
                                const refreshRequest = req.clone({
                                    headers: req.headers.set(
                                        'Authorization', "Bearer " + localStorage.getItem("Authorization-Token")
                                    ),
                                    url: domain + req.url
                                });
                                return next.handle(refreshRequest)
                            }), catchError(err => {
                                this.authService.handleLogout();
                                return throwError(err);
                            })
                        );
                    }
                } else {
                    let errorMessage;
                    if (err.error instanceof ErrorEvent) {
                        errorMessage = `Error: ${err.error.message}`;
                    } else {
                        errorMessage = `Error: ${err.message}`;
                    }
                    window.alert(errorMessage);
                }
                return throwError(err);
            })
        );
    }

    private startInactivityTimer(): void {
        this.resetInactivityTimer();
    }

    private resetInactivityTimer(): void {
        // Cancel the existing timer if it exists
        if (this.inactivityTimer$) {
            this.inactivityTimer$.unsubscribe();
        }
        // Start a new timer
        var data = {
            access_token: localStorage.getItem("Authorization-Token")
        }
        this.inactivityTimer$ = timer(this.inactivityTimeout).subscribe({
            next: () => {
                this.authService.handleLogout();
                this.router.navigate(['/auth/login']);
            },

            error: err => console.error('Error in inactivity timer:', err)
        });
    }
}

